import { FC, useCallback } from "react";
import { Box, Button, Paper, Stack, Typography } from "@mui/material";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import useBasePath from "src/utils/hooks/useBasePath";
import __ from "src/utils/Translations";
import { downloadImportTemplateFile } from "src/Pages/Company/Absences/api/useDownloadFile";
import BreadcrumbsMui from "src/Components/BreadcrumbsMui/BreadcrumbsMui";
import Title from "src/Pages/Company/Absences/Title/Title";
import ImportForm from "src/Pages/Company/Absences/AbsenceRecords/AbsenceRecordsImports/ImportForm";
import { ImportType } from "src/Pages/Company/Absences/AbsenceRecords/AbsenceRecords.models";

const AbsenceRequestsImport: FC = () => {
  const basePath = useBasePath();

  const handleTemplateImport = useCallback(() => {
    downloadImportTemplateFile(ImportType.ABSENCE_REQUESTS);
  }, []);

  return (
    <Box sx={{ position: "relative" }}>
      <BreadcrumbsMui
        items={[
          {
            label: __("Nieobecności"),
            to: `${basePath}/absences`,
          },
          {
            label: __("Import wniosków z innego systemu"),
          },
        ]}
      />
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Title title={__("Import wniosków z innego systemu")} />
      </Box>
      <Paper sx={{ p: "2rem" }} data-testid="absence-requests-import">
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography component="h2" variant="h6" margin="normal">
            {__("Eksport szablonu importów")}
          </Typography>
          <Button
            variant="contained"
            onClick={handleTemplateImport}
            startIcon={<FileDownloadOutlinedIcon />}
          >
            {__("Eksportuj")}
          </Button>
        </Stack>
      </Paper>
      <ImportForm importType={ImportType.ABSENCE_REQUESTS} />
    </Box>
  );
};

export default AbsenceRequestsImport;
